{
 "code": "SA485",
 "edition": "SA485.2607",
 "pageSize": [
  595.28,
  841.89
 ],
 "source": "https://www.servicesaustralia.gov.au/sa485",
 "fields": {
  "q1_residential": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     110.7,
     442.3,
     121.8,
     453.4
    ]
   ]
  },
  "q2_yes": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     65.3,
     642.2,
     76.4,
     653.3
    ]
   ]
  },
  "q3_yes": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     65.3,
     725.8,
     76.4,
     736.9
    ]
   ]
  },
  "q4_no": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     348.8,
     154.6,
     359.9,
     165.7
    ]
   ]
  },
  "q4_yes": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     348.8,
     170.2,
     359.9,
     181.3
    ]
   ]
  },
  "q4_name": {
   "kind": "text",
   "page": 4,
   "boxes": [
    [
     331.8,
     200.0,
     566.8,
     239.4
    ]
   ]
  },
  "q4_relationship": {
   "kind": "text",
   "page": 4,
   "boxes": [
    [
     331.8,
     256.7,
     566.8,
     276.3
    ]
   ]
  },
  "q5_no": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     348.8,
     595.4,
     359.9,
     606.5
    ]
   ]
  },
  "q5_yes": {
   "kind": "tick",
   "page": 4,
   "boxes": [
    [
     348.8,
     613.8,
     359.9,
     624.9
    ]
   ]
  },
  "q6_na": {
   "kind": "tick",
   "page": 5,
   "boxes": [
    [
     110.7,
     141.9,
     121.8,
     152.9
    ]
   ]
  },
  "q6_yes": {
   "kind": "tick",
   "page": 5,
   "boxes": [
    [
     110.7,
     207.1,
     121.8,
     218.1
    ]
   ]
  },
  "q8_you_family": {
   "kind": "text",
   "page": 5,
   "boxes": [
    [
     48.3,
     449.4,
     283.3,
     469.0
    ]
   ]
  },
  "q8_you_first": {
   "kind": "text",
   "page": 5,
   "boxes": [
    [
     48.3,
     484.8,
     283.3,
     504.4
    ]
   ]
  },
  "q9_you_dob": {
   "kind": "date",
   "page": 5,
   "boxes": [
    [
     48.4,
     570.0,
     76.5,
     589.6
    ],
    [
     82.5,
     570.0,
     110.6,
     589.6
    ],
    [
     116.5,
     570.0,
     172.9,
     589.6
    ]
   ]
  },
  "q8_partner_family": {
   "kind": "text",
   "page": 5,
   "boxes": [
    [
     331.8,
     449.4,
     566.8,
     469.0
    ]
   ]
  },
  "q8_partner_first": {
   "kind": "text",
   "page": 5,
   "boxes": [
    [
     331.8,
     484.8,
     566.8,
     504.4
    ]
   ]
  },
  "q9_partner_dob": {
   "kind": "date",
   "page": 5,
   "boxes": [
    [
     331.9,
     570.0,
     360.0,
     589.6
    ],
    [
     365.9,
     570.0,
     394.0,
     589.6
    ],
    [
     399.9,
     570.0,
     456.4,
     589.6
    ]
   ]
  },
  "q12_option1": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     221.2,
     367.6,
     232.3,
     378.6
    ]
   ]
  },
  "q13_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     181.5,
     359.9,
     192.6
    ]
   ]
  },
  "q13_yes": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     200.0,
     359.9,
     211.1
    ]
   ]
  },
  "q16_yes": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     65.3,
     245.3,
     76.4,
     256.4
    ]
   ]
  },
  "q17_yes": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     65.3,
     397.0,
     76.4,
     408.1
    ]
   ]
  },
  "q19_no": {
   "kind": "tick",
   "page": 8,
   "boxes": [
    [
     65.3,
     69.6,
     76.4,
     80.7
    ]
   ]
  },
  "q20_no": {
   "kind": "tick",
   "page": 8,
   "boxes": [
    [
     348.8,
     106.4,
     359.9,
     117.5
    ]
   ]
  },
  "q20_yes": {
   "kind": "tick",
   "page": 8,
   "boxes": [
    [
     348.8,
     126.3,
     359.9,
     137.4
    ]
   ]
  },
  "q20_type": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     336.0,
     160.3,
     562.6,
     179.9
    ]
   ]
  },
  "q20_value": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     336.0,
     197.1,
     446.3,
     216.7
    ]
   ],
   "padLeft": 12.2
  },
  "q20_share_you": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     395.6,
     238.2,
     446.3,
     257.8
    ]
   ]
  },
  "q20_share_partner": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     511.8,
     238.2,
     562.6,
     257.8
    ]
   ]
  },
  "q20_partner_no": {
   "kind": "tick",
   "page": 8,
   "boxes": [
    [
     353.0,
     319.0,
     364.1,
     330.1
    ]
   ]
  },
  "q20_partner_yes": {
   "kind": "tick",
   "page": 8,
   "boxes": [
    [
     353.0,
     337.4,
     364.1,
     348.5
    ]
   ]
  },
  "q22_o1_select": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     181.5,
     95.1,
     192.6,
     106.2
    ]
   ]
  },
  "q22_o2_select": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     181.5,
     399.8,
     192.6,
     410.9
    ]
   ]
  },
  "q22_o1_value": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     52.6,
     153.2,
     162.9,
     172.8
    ]
   ],
   "padLeft": 12.2
  },
  "q22_o1_loan": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     168.8,
     153.2,
     279.1,
     172.8
    ]
   ],
   "padLeft": 12.2
  },
  "q22_o1_share_you": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     112.1,
     192.9,
     162.9,
     212.5
    ]
   ]
  },
  "q22_o1_share_partner": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     228.3,
     192.9,
     279.1,
     212.5
    ]
   ]
  },
  "q22_o1_share_other": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     112.1,
     218.4,
     162.9,
     238.0
    ]
   ]
  },
  "q22_o1_partner_no": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     69.6,
     272.3,
     80.7,
     283.3
    ]
   ]
  },
  "q22_o1_partner_yes": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     69.6,
     290.7,
     80.7,
     301.8
    ]
   ]
  },
  "q22_o2_value": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     52.6,
     533.7,
     162.9,
     553.3
    ]
   ],
   "padLeft": 12.2
  },
  "q22_o2_remaining": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     168.8,
     533.7,
     279.1,
     553.3
    ]
   ],
   "padLeft": 12.2
  },
  "q22_o2_loan": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     52.6,
     583.4,
     162.9,
     602.9
    ]
   ],
   "padLeft": 12.2
  },
  "q22_o2_share_you": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     112.1,
     623.0,
     162.9,
     642.6
    ]
   ]
  },
  "q22_o2_share_partner": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     228.3,
     623.0,
     279.1,
     642.6
    ]
   ]
  },
  "q22_o2_share_other": {
   "kind": "text",
   "page": 9,
   "boxes": [
    [
     112.1,
     648.6,
     162.9,
     668.1
    ]
   ]
  },
  "q22_o2_partner_no": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     69.6,
     705.2,
     80.7,
     716.3
    ]
   ]
  },
  "q22_o2_partner_yes": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     69.6,
     723.7,
     80.7,
     734.8
    ]
   ]
  },
  "q26_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     93.7,
     76.4,
     104.8
    ]
   ]
  },
  "q26_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     112.1,
     76.4,
     123.2
    ]
   ]
  },
  "q26_value": {
   "kind": "text",
   "page": 10,
   "boxes": [
    [
     85.2,
     139.0,
     195.5,
     158.6
    ]
   ],
   "padLeft": 12.2
  },
  "q27_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     256.7,
     76.4,
     267.7
    ]
   ]
  },
  "q28_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.5,
     381.4,
     76.6,
     392.5
    ]
   ]
  },
  "q28_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.5,
     399.8,
     76.6,
     410.9
    ]
   ]
  },
  "q30_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     348.8,
     58.2,
     359.9,
     69.3
    ]
   ]
  },
  "q30_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     348.8,
     76.7,
     359.9,
     87.7
    ]
   ]
  },
  "q31_carer": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     501.9,
     238.4,
     512.9,
     249.5
    ]
   ]
  },
  "q31_relative": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     501.9,
     281.6,
     512.9,
     292.7
    ]
   ]
  },
  "q31_none": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     501.9,
     304.2,
     512.9,
     315.3
    ]
   ]
  }
 }
}